/* ─── Sostenimiento: flag de la sección de ofrendas del landing ───
   Controlado por el flag del backend (`activo`, que sale de
   ConfiguracionCostos.sostenimiento_fecha_activacion — editable por Super
   Admin en /admin/, sin desplegar código): mientras el sostenimiento no
   esté activo, la sección #ofrenda (y el bloque #ofrendar dentro de ella)
   se oculta por completo — nada de ofrendas se menciona ahí hasta el
   lanzamiento. La página de registro no depende de este flag: solo
   menciona que el proyecto se sostiene con ofrendas, sin cifras.

   El endpoint es público y de solo lectura: no requiere clave. */
(function () {
  const isLocal = ['localhost', '127.0.0.1'].includes(location.hostname);
  const API_BASE = isLocal ? 'http://localhost:8080' : 'https://api.ekleria.pe';

  const ofrendaSection = document.getElementById('ofrenda');
  if (!ofrendaSection) return;

  const ocultarSeccionOfrenda = () => {
    ofrendaSection.hidden = true;
    document.querySelectorAll('a[href="#ofrenda"], a[href="#ofrendar"]').forEach((a) => {
      (a.closest('li') || a).hidden = true;
    });
  };

  fetch(API_BASE + '/api/public/ofrendas/info/')
    .then((res) => { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
    .then((data) => { if (!data.activo) ocultarSeccionOfrenda(); })
    .catch(() => {
      // Sin respuesta del backend: por defecto se mantiene oculta (recién
      // entra en vigencia desde la fecha configurada; no se muestra "por si acaso").
      ocultarSeccionOfrenda();
    });
})();
